import { render } from "./PayrollWageList.vue?vue&type=template&id=54aa9454"
import script from "./PayrollWageList.vue?vue&type=script&lang=js"
export * from "./PayrollWageList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__